import { TRACKING_CONFIG as C } from "./config";

const configured = (v) => typeof v === "string" && v.length > 0;

export function initDataLayer() {
    window.dataLayer = window.dataLayer || [];
    window.gtag =
        window.gtag ||
        ((...args) => {
            window.dataLayer.push(args);
        });
}

// Loads Meta Pixel only when enabled AND configured. GA4's base tag loads
// from public/index.html; the Google loader below stays dormant until an Ads
// conversion ID is provided, and never double-loads the gtag script.
export function initTracking() {
    initDataLayer();
    const g = C.google;
    const gtagAlreadyLoaded = !!document.querySelector(
        'script[src*="googletagmanager.com/gtag"]'
    );
    if (
        g.enabled &&
        configured(g.measurementId) &&
        !gtagAlreadyLoaded &&
        !document.getElementById("gtag-src")
    ) {
        const s = document.createElement("script");
        s.async = true;
        s.id = "gtag-src";
        s.src = `https://www.googletagmanager.com/gtag/js?id=${g.measurementId}`;
        document.head.appendChild(s);
        window.gtag("js", new Date());
        window.gtag("config", g.measurementId);
    }
    if (g.enabled && configured(g.adsId)) {
        window.gtag("config", g.adsId);
    }
    if (C.meta.enabled && configured(C.meta.pixelId) && !window.fbq) {
        (function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function (...a) {
                n.callMethod
                    ? n.callMethod.apply(n, a)
                    : n.queue.push(a);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = true;
            n.version = "2.0";
            n.queue = [];
            t = b.createElement(e);
            t.async = true;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
        window.fbq("init", C.meta.pixelId);
        window.fbq("track", "PageView");
    }
}

export function trackEvent(name, params = {}) {
    initDataLayer();
    window.dataLayer.push({ event: name, ...params });
    if (window.gtag) window.gtag("event", name, params);
}

// GA4's automatic page_view covers the initial load; this tracks SPA route changes.
export function trackPageView(path) {
    initDataLayer();
    window.dataLayer.push({ event: "spa_page_view", page_path: path });
    if (typeof window.gtag === "function") {
        window.gtag("event", "page_view", {
            page_path: path,
            page_location: window.location.href,
        });
    }
}

export function trackAuditCta(ctaLocation) {
    trackEvent("audit_cta_click", { cta_location: ctaLocation });
}

let leadSent = false;
// Fire once, only after a successful form submission (never on click).
export function trackLeadSubmit() {
    if (leadSent) return;
    leadSent = true;
    trackEvent("generate_lead", { lead_type: "audit_request" });
    const g = C.google;
    if (
        g.enabled &&
        configured(g.adsId) &&
        configured(g.adsConversionLabel) &&
        window.gtag
    ) {
        window.gtag("event", "conversion", {
            send_to: `${g.adsId}/${g.adsConversionLabel}`,
        });
    }
    if (C.meta.enabled && window.fbq) {
        window.fbq("track", "Lead", { lead_type: "audit_request" });
    }
}

let bookingSent = false;
// Calendly fires `calendly.event_scheduled` to the parent window after a real booking.
// dataLayer only: the Google Ads conversion for this flow is URL-based
// (the /thank-you page load); GA4 is not used for conversion tracking here.
export function trackIntroMeetingBooked(payload = {}) {
    if (bookingSent) return;
    bookingSent = true;
    initDataLayer();
    window.dataLayer.push({
        event: "intro_meeting_booked",
        lead_type: "intro_meeting",
        ...payload,
    });
    if (C.meta.enabled && window.fbq) {
        window.fbq("track", "Lead", { lead_type: "intro_meeting" });
    }
}
